/**
 * پیاده‌سازیِ پورت‌های core برای مرورگر — نسخه‌ی کمینه‌ی اپِ ادمین.
 *
 * باید **اولین import** در main.tsx باشد، به همان دلیلی که در وب و موبایل
 * هست: importها قبل از بدنه‌ی ماژول اجرا می‌شوند، پس اگر فایلِ دیگری زودتر
 * به چیزی از core برسد که فوری پورت لازم دارد، initCore هنوز صدا زده نشده.
 *
 * ═══ چرا کپیِ کوچکی از apps/web/src/boot.ts است و نه importش ═══
 *
 * قاعده‌ی مونوریپو: هرگز app→app. دو اپِ مرورگری داریم و هر کدام آداپترِ
 * خودش را تزریق می‌کند. بردنِ این به core هم درست نبود — core عمداً
 * پلتفرم‌ندار است و `window` را نمی‌شناسد.
 *
 * ولی این نسخه عمداً **کوچک‌تر** است: ادمین نه به تشخیصِ شهر از IP نیاز
 * دارد، نه به نسخه‌ی مرورگر برای گزارشِ باگِ کاربر. فقط ذخیره‌سازیِ نشست و
 * حداقلِ اطلاعاتِ پلتفرم.
 */
import { initCore } from '@/core/platform';
import type { KeyValueStore, PlatformInfo } from '@/core/ports';

/**
 * localStorage همزمان است و core رابطِ Promise می‌خواهد، پس فقط دورش پیچیده
 * می‌شود. try/catch لازم است: در حالتِ ناشناسِ بعضی مرورگرها خودِ خواندن
 * throw می‌کند، و آن‌وقت باید مثل «چیزی ذخیره نشده» رفتار کنیم نه اینکه کلِ
 * صفحه بالا نیاید.
 */
const storage: KeyValueStore = {
  async getItem(key) {
    try { return window.localStorage.getItem(key); } catch { return null; }
  },
  async setItem(key, value) {
    try { window.localStorage.setItem(key, value); } catch { /* در دسترس نیست */ }
  },
  async removeItem(key) {
    try { window.localStorage.removeItem(key); } catch { /* در دسترس نیست */ }
  },
};

const platform: PlatformInfo = {
  os: 'web',
  // برخلافِ سایت، نسخه‌ی مرورگر این‌جا استخراج نمی‌شود: تنها کاربرِ این اپ
  // خودمانیم و «سافاری فلان باگ را دارد» مسئله‌ی این صفحه نیست.
  osVersion: 'admin',
  appVersion: import.meta.env.VITE_APP_VERSION ?? null,
  isWeb: true,
};

initCore({
  storage,
  platform,
  supabaseUrl: import.meta.env.VITE_SUPABASE_URL ?? '',
  supabaseAnonKey: import.meta.env.VITE_SUPABASE_ANON_KEY ?? '',
  // نه imageCache و نه ipLocation: اولی را مرورگر خودش می‌کند و دومی یک
  // تماسِ شخصِ ثالث است که ابزارِ داخلی هیچ دلیلی برایش ندارد.
});
